import React from "react";
import PropTypes from "prop-types";

import "./Screen.scss";

const Screen = ({ children, className, ...props }) => {
	return (
		<div
			{...props}
			className={`${className} payment-screen`}
		>
			{children}
		</div>
	);
};

Screen.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
};


Screen.defaultProps = {
	children: null,
	className: "",
};
export default Screen;



// WEBPACK FOOTER //
// ./src/shared/payment/components/Screen/index.jsx